import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { DatasourceServiceProvider } from './services/datasource/datasource.service.provider';
import { WorkflowServiceProvider } from './services/workflow/workflow.service.provider';
import { ResponseWorkflowServiceProvider } from './services/responses/response-workflow.service.provider';
import { AuthServiceProvider } from './services/auth/auth.service.provider';
import { ResponseWorkflowOnlineService } from './services/responses/response-workflow-online.service';
import { UnitOfWorkOfflineDao } from './daos/unitofwork-offline.dao';
import { VariableEnvironnementUserServiceProvider } from './services/variable-environnement-user/variable-environnement-user.service.provider';
import { VariableEnvironnementUserOnlineService } from './services/variable-environnement-user/variable-environnement-user-online.service';
import { DatasourceOnlineService } from './services/datasource/datasource-online.service';
import { PlatformServiceProvider } from './platform/platform.service.provider';
import { PlatformAndroidService } from './platform/platform-android.service';
import { DatasourceOfflineDaoProvider } from './daos/datasource/datasource-offline.dao.provider';
import { EnvVarUserOfflineDaoProvider } from './daos/envvaruser/envvaruser-offline.dao.provider';
import { ResponseWorkflowOfflineDaoProvider } from './daos/response-workflow/response-workflow-offline.dao.provider';
import { WorkflowOfflineDaoProvider } from './daos/workflow/workflow-offline.dao.provider';
import { SignalRServiceProvider } from './signalr/signalr.service.provider';
import { LogEnvVarUserOfflineDaoProvider } from './daos/log-envvaruser/log-envvaruser-offline.dao.provider';
import { LogVariableEnvironnementUserServiceProvider } from './services/log-variable-environnement-user/log-variable-environnement-user.service.provider';
import { LogVariableEnvironnementUserOnlineService } from './services/log-variable-environnement-user/log-variable-environnement-user-online.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
    ],
    providers: [
        DatasourceOfflineDaoProvider,
        EnvVarUserOfflineDaoProvider,
        ResponseWorkflowOfflineDaoProvider,
        WorkflowOfflineDaoProvider,
        LogEnvVarUserOfflineDaoProvider,

        UnitOfWorkOfflineDao,

        ResponseWorkflowOnlineService,
        VariableEnvironnementUserOnlineService,
        DatasourceOnlineService,
        LogVariableEnvironnementUserOnlineService,
        
        DatasourceServiceProvider,
        WorkflowServiceProvider,
        ResponseWorkflowServiceProvider,
        AuthServiceProvider,
        VariableEnvironnementUserServiceProvider,
        LogVariableEnvironnementUserServiceProvider,

        PlatformAndroidService,
        PlatformServiceProvider,

        SignalRServiceProvider,
    ]
})
export class CoreApiModule {}